import * as React from 'react';
import * as style from './style.css';
import { ArticleParagraph1, Image, UIText2 } from '@cian/ui-kit';

interface IAwardCardProps {
  place: number;
  placeLabel: string;
  description: string;
  icon: string;
}

export const RatingCard = ({ place, placeLabel, description, icon }: IAwardCardProps) => {
  return (
    <div className={style['card']}>
      <div className={style['place-wrapper']}>
        <div className={style['place']}>
          <div className={style['place-number']}>{place}</div>
          <ArticleParagraph1>{placeLabel}</ArticleParagraph1>
        </div>
        <div className={style['icon']}>
          <Image src={icon} alt={`${place} ${description}`} preloader={false} height={45} width={45} />
        </div>
      </div>
      <UIText2>{description}</UIText2>
    </div>
  );
};
